import { useAtomValue, useSetAtom } from 'jotai';
import { atomWithReset, useResetAtom } from 'jotai/utils';

export type ModalTypes =
  | 'idleTime'
  | 'sendLink'
  | 'consumerAccounts'
  | 'cartItem'
  | 'storeSelector'
  | 'applyDisabled'
  | 'checkoutDisabled'
  | 'checkoutLenderDisabled'
  | 'changePassword';

const CurrentModal = atomWithReset<ModalTypes | undefined>(undefined);

export const useGetCurrentModal = () => useAtomValue(CurrentModal);
export const useSetCurrentModal = () => useSetAtom(CurrentModal);
export const useResetCurrentModal = () => useResetAtom(CurrentModal);
